import { render, staticRenderFns } from "./RegisterSampleLotProductionVG.vue?vue&type=template&id=04757f67"
import script from "./RegisterSampleLotProductionVG.vue?vue&type=script&lang=js"
export * from "./RegisterSampleLotProductionVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports